/* eslint-disable */
export default function (object: any, tree: string) {
  return tree.split(".").reduce((acc, curr) => {
    if (curr.includes("[")) {
      const [prop, idx] = curr.split("[");
      return acc[prop][idx.slice(0, -1)];
    }
    return acc[curr];
  }, object);
}
